import initialState from './initialState'
import { GET_VALIDATION_MERCHANT, FETCHING_VALIDATION_MERCHANT, ERROR_FETCHING_VALIDATION_MERCHANT } from '../actions/constants'

const register = (state = initialState.register, action = {}) => {
  switch (action.type) {
    case FETCHING_VALIDATION_MERCHANT:
      return {...state, loading: true}
    case GET_VALIDATION_MERCHANT:
      return {...state, loading: false, data: action.data}
    case ERROR_FETCHING_VALIDATION_MERCHANT:
      return {...state, loading: false, error: action.error}
    default: return state
  }
}

export default register
